module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-dashboard-user-guide_item"
  }, [_c('a', {
    attrs: {
      "href": _vm.href,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "lxm-dashboard-user-guide_item-img",
    attrs: {
      "src": _vm.image,
      "alt": _vm.name
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72237b55", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72237b55!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Dashboard/components/GuideItem.vue
// module id = 867
// module chunks = 0